<template>
  <w-flex direction="col" align="stretch" class="actions-bar-mobile w-theme--dark" :gap="3">
    <w-flex class="actions-bar-mobile__row" tag="footer" justify="space-b" :gap="4">
      <w-button size="xl" icon="menu" variant="outlined" @click="$emit('openNavigation')" />

      <w-button
        v-if="isLastTab"
        fluid
        size="xl"
        text-align="center"
        justify="center"
        icon-position="right"
        color="primary"
        icon="save"
        text="Zapisz i wyjdź"
        @click="$emit('save', true)"
      />

      <w-button
        v-else
        fluid
        size="xl"
        text-align="center"
        justify="center"
        icon-position="right"
        color="primary"
        icon="chevron_right"
        text="Dalej"
        @click="$emit('goNext')"
      />
    </w-flex>

    <w-flex class="actions-bar-mobile__row" justify="end">
      <autosave-info class="mr-4" :need-autosave="needAutosave" />

      <w-button
        size="xs"
        color="primary"
        variant="tonal"
        text="Zapisz"
        icon="save"
        @click="$emit('save', false)"
      />
    </w-flex>
  </w-flex>
</template>

<script setup lang="ts">
import AutosaveInfo from './AutosaveInfo.vue';

defineProps<{
  isSuperAdmin?: boolean;
  needAutosave?: boolean;
  isLastTab?: boolean;
}>();

defineEmits({
  save: null,
  goNext: null,
  openNavigation: null,
});
</script>

<style lang="scss">
.actions-bar-mobile {
  background: w.color('neutral', 100);
  color: w.color('text');
  padding: 8px;

  .w-btn {
    &--fluid {
      flex: 1;
      width: unset;
    }
  }
}
</style>
